import { formTemplateStatusEnum } from '../enums';

export const formTemplateStatusEnumColors: Record<number, string> = {
    [formTemplateStatusEnum.DRAFT]: 'yellow',
    [formTemplateStatusEnum.PUBLISHED]: 'green',
    [formTemplateStatusEnum.INACTIVE]: 'gray',
};

export const getFormTemplateStatusColor = (state?: number): string => {
    return state !== undefined ? (formTemplateStatusEnumColors[state] ?? '') : '';
};
